import { Component } from '@angular/core';
import { OrganizationService } from '../../organization.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-organization-address-add',
	templateUrl: './organization-address-add.component.html',
	styleUrls: ['./organization-address-add.component.css'],
})
export class OrganizationAddressAddComponent {
	formAdress: FormGroup<any> = this.formBuilder.group({
		address: new FormControl(null, [Validators.required]),
		zipCode: new FormControl(null, [Validators.required]),
		location: new FormControl(null, [Validators.required]),
		type: new FormControl(null, [Validators.required]),
	});
	constructor(
		public service: OrganizationService,
		private readonly formBuilder: FormBuilder,
		public dialog: MatDialog,
	) {}

	addAddress() {
		if (this.formAdress.status === 'INVALID') return;
		this.service.organizationData.address.push({
			address: this.formAdress.controls.address.value,
			zipCode: this.formAdress.controls.zipCode.value,
			location: this.formAdress.controls.location.value,
			kind: this.formAdress.controls.type.value,
		});
		this.dialog.closeAll();
	}
}
